export class AnnualReviewDelegationPayload {
	constructor(obj) {
		/**
		 * user to be the delegatee
		 * @type {object[]}
		 */
		this.delegatee = obj.delegatee ?? [];

		/**
		 * beginning date for delegation
		 * @type {string}
		 */
		this.startDate = obj.startDate ?? '';

		/**
		 * ending date for delegation
		 * @type {string}
		 */
		this.endDate = obj.endDate ?? '';

		/**
		 * list of staff to be delegated to the aforementioned delegatee
		 * @type {object[]}
		 */
		this.usersList = obj.usersList ?? [];

		/**
		 * currently logged in user
		 * @type {object}
		 */
		this.createUser = obj.createUser ?? '';

		/**
		 * currently logged in user
		 * @type {object}
		 */
		this.maintenanceUser = obj.maintenanceUser ?? '';
	}

	prepare(loggedInUser) {
		return {
			delegatee: this.delegatee,
			startDate: this.startDate,
			endDate: this.endDate,
			usersList: this.usersList,
			createUser: loggedInUser ?? this.createUser,
			maintenanceUser: loggedInUser ?? this.maintenanceUser,
		};
	}
}
